<template>
  <Modal :title="$t('configuration_management.common.operationLog')" v-model="dialogVisible" width="55%" footer-hide :styles="{top:'80px'}">
    <Row :gutter="4" style="margin-bottom: 10px;">
      <Col span="6">
        <DatePicker type="date" :placeholder="$t('configuration_management.common.pleaseSelectStartTime')" v-model="startTime" style="width:100%;"></DatePicker>
      </Col>
      <Col span="6">
        <DatePicker type="date" :placeholder="$t('configuration_management.common.pleaseSelectEndTime')" v-model="endTime"  style="width:100%;"></DatePicker>
      </Col>
      <Col span="4">
        <Button type="success" @click="changeDate()">{{$t('configuration_management.common.selectButton')}}</Button>
      </Col>
    </Row>
    <Table :no-data-text="$t('common.noData')" :columns="columns" :data="configurationManagementOperationLogs" style="width: 100.1%;" class="table-css"
           height="500"></Table>
  </Modal>
</template>
<script>
  let configurationManagementOperationLog = {};
  export default {
    name: 'ConfigurationManagementOperationLog',
    data() {
      return {
        rowId:0,
        moduleType:0,
        dialogVisible: false,
        startTime:'',
        endTime:'',
        columns: [
          {
            title: this.$t('configuration_management.common.changeField'),
            key: 'fieldName'
          },
          {
            title: this.$t('configuration_management.common.originalValue'),
            key: 'oldValue'
          },
          {
            title: this.$t('configuration_management.common.newValue'),
            key: 'newValue'
          },
          {
            title: this.$t('configuration_management.common.operator'),
            key: 'createdBy'
          },
          {
            title: this.$t('configuration_management.common.operatingTime'),
            key: 'createdTime'
          }
        ],
        configurationManagementOperationLogs: []
      }
    },
    beforeCreate: function () {
      configurationManagementOperationLog = this
    },
    methods: {
      getConfigurationManagementOperationLogList: function (rowId,
       moduleType) {
        this.rowId = rowId;
        this.moduleType = moduleType;
        this.dialogVisible = true;
        this.configurationManagementOperationLogs = [];
        this.$api.configurationManagementOperationLog.getConfigurationManagementOperationLogs({
          "moduleType": moduleType,
          "rowId": rowId
        })
          .then(res => {
            if (res.data != null && res.data != undefined && res.data.length > 0) {
              this.configurationManagementOperationLogs = res.data;
            }
          });
      },
      changeDate: function () {
        this.dialogVisible = true;
        this.configurationManagementOperationLogs = [];
        this.$api.configurationManagementOperationLog.getConfigurationManagementOperationLogs({
          "moduleType": this.moduleType,
          "rowId": this.rowId,
          "startTime":this.startTime,
          "endTime":this.endTime
        })
        .then(res => {
          if (res.data != null && res.data != undefined && res.data.length > 0) {
            this.configurationManagementOperationLogs = res.data;
          }
        });
      }
    }
  }
</script>
<style scoped>
  /* 滚动条 */
  .table-css >>> .ivu-table-overflowY::-webkit-scrollbar {
    width: 10px;
    height: 10px;
  }

  .table-css >>> .ivu-table-overflowY::-webkit-scrollbar-thumb {
    border-radius: 5px;
    background: #ccc;
  }

  .table-css >>> .ivu-table-overflowY::-webkit-scrollbar-track {
    background: #eeeeef;
  }

  .table-css >>> .ivu-table-overflowY::-webkit-scrollbar-corner {
    background-color: #eeeeef;
  }

  .table-css >>> .ivu-table-overflowX {
    overflow-x: hidden !important;
  }
</style>



// WEBPACK FOOTER //
// src/components/configuration/common/ConfigurationManagementOperationLog.vue